import { routeToProduct } from '@/helpers';

import ImageCard from '@/components/@general/ImageCard/index.vue';
import StarRating from 'vue-star-rating';
import IconVerify from '@/components/icons/IconVerify.vue';
import IconShareInstagram from '@/components/icons/IconShareInstagram.vue';
import IconShareFacebook from '@/components/icons/IconShareFacebook.vue';

export default {
  name: 'ReviewProfessionalCard',
  components: {
    IconShareFacebook,
    IconShareInstagram,
    IconVerify,
    ImageCard,
    StarRating
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {};
  },

  created() {},
  mounted() {},
  computed: {},

  methods: {
    routeToProduct
  }
};
